function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function closePopup(cname, cvalue, exdays) {
    jQuery('#std-modal').removeClass('active');
    setCookie(cname, cvalue, exdays);
}


(function($) {

    $(document).on( 'click', '#lang-menu.show', function() {

        $(this).removeClass('show');

    });

    $(document).on( 'click', '#wrapper-navbar .navbar-toggler', function() {

        if($('#wrapper-navbar').hasClass('open')){
            $('body').removeClass('noscroll');
            $('#wrapper-navbar').removeClass('open');
            $('.navbar-istitutional').removeClass('open');
        } else {
            $('body').addClass('noscroll');
            $('#wrapper-navbar').addClass('open');
            $('.navbar-istitutional').addClass('open');
        }
        

    });

	//prelogin-page
	$('#message-modal-wrapper .modal-exit').on('click', function () {
		var currentLang = $(this).attr('data-lang');
		setCookie('modal-check-' + currentLang, 1, { expires: 5 });
		$('#message-modal-wrapper').addClass("hidden");
		$('html').removeClass("noscroll");
	});
    

})
(jQuery);
